import type { CollectionState, CollectionAdapter } from '@common/adapters/collections';
import type { EduSchool } from '@common/types/edu-course.type';

import { createReducer, on } from '@ngrx/store';
import { createCollectionAdapter } from '@common/adapters/collections';

import EduSchoolsActions from './edu-schools.actions';

export const EDU_SCHOOLS_COLLECTIONS_FEATURE_KEY = 'eduSchools';

export type EduSchoolsCollectionState = CollectionState<EduSchool>;

export const eduSchoolsAdapter: CollectionAdapter<EduSchool> = createCollectionAdapter<EduSchool>();

export const eduSchoolsCollectionReducer = createReducer<EduSchoolsCollectionState>(
    eduSchoolsAdapter.getInitialState(),
    on(EduSchoolsActions.loadCollectionRequest, (state: EduSchoolsCollectionState) =>
        eduSchoolsAdapter.loadCollectionRequest(state)
    ),
    on(EduSchoolsActions.loadCollectionSuccess, (state: EduSchoolsCollectionState, { schools }) =>
        eduSchoolsAdapter.loadCollectionSuccess(schools, state)
    ),
    on(EduSchoolsActions.loadCollectionFailure, (state: EduSchoolsCollectionState, { error }) =>
        eduSchoolsAdapter.loadCollectionFailure(error, state)
    )
);
